import { IntercomProvider } from 'react-use-intercom';
import { client } from './api-models/client.gen';
import getBackendUrl from './utils/backendUrl';
import AppLayout from './components/app-layout/appLayout';
import AuthProvider from './components/app-layout/context/authProvider';
import ModalProvider from './components/modalProvider';
import SnapshotProvider from './components/app-layout/context/snapshotProvider';
import OrganisationSettingsProvider from './components/organisation-settings/organisationSettingsProvider';

client.setConfig({
  baseUrl: getBackendUrl(),
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
  },
});

client.interceptors.response.use((response) => {
  if (!response) {
    // If an error is unknown to us, or is an error not thrown by the backend
    throw new Error('No response');
  }
  return response;
});

function App() {
  return (
    <AuthProvider>
      <IntercomProvider appId={import.meta.env.VITE_INTERCOM_APP_ID}>
        <ModalProvider>
          <OrganisationSettingsProvider>
            <SnapshotProvider>
              <AppLayout />
            </SnapshotProvider>
          </OrganisationSettingsProvider>
        </ModalProvider>
      </IntercomProvider>
    </AuthProvider>
  );
}

export default App;
